import React, { useState, useEffect } from 'react';
import { NOTIFICATION_HANDLER } from '@Constants/types';
import { LOG_TYPE, addLog } from '@Service/loggingService';
import { useDispatch, useSelector } from 'react-redux';
import { navigateTextInBody } from '@Actions/wordApiActions';
import store from '@Store';
import { ItemContainer, ErrorText, ItemParagraph, ItemWrapper } from './MetaDataValue.style';
import { MIX_PANEL } from '@Constants/types';
import mixpanelEvents from '@Mixpanel';

const MetaDataValue = ({
    index,
    metaDataItem,
    name,
    labelIndex,
    valuePosition,
    numOfExtractions,
    ...rest
}) => {
    const [navigateIndex, setNavigateIndex] = useState(0);
    const [isNavigable, setIsNavigable] = useState(true);
    const [valueIndex, setValueIndex] = useState('');

    const dispatch = useDispatch();
    const { navigating, navigatingTo, navigationFailedFlag, clearNavigateCountFlag } = useSelector(
        state => state.search
    );

    const { index: navigatingToIndex } = navigatingTo;

    useEffect(() => {
        setValueIndex(index);
        setIsNavigable(metaDataItem.navigableFlag);
    }, []);

    useEffect(
        () => {
            if (navigateIndex > 0) {
                setNavigateIndex(1); // cycle reset to first item
            } else {
                setNavigateIndex(0); // initial load conditions
            }
            if (navigatingTo) {
                if (valueIndex === navigatingToIndex) {
                    if (isNavigable === navigationFailedFlag) {
                        setIsNavigable(!navigationFailedFlag);
                    }
                }
            }
        },
        [clearNavigateCountFlag]
    );

    const metadataValueClickHandler = (metaDataItemInput, indexInput) => {
        try {
            const text = metaDataItemInput.value;
            if (metaDataItemInput.navigableFlag && !navigating) {
                const mixpanel = {
                    displayId: name,
                    labelPosition: labelIndex,
                    numberOfExtractions: numOfExtractions,
                    numberOfCharsInExtraction: text.length
                };
                store.dispatch({
                    type: MIX_PANEL.MIXPANEL_DATA_LABELS,
                    payload: mixpanel
                });

                mixpanelEvents.labelclickedShowonDocument();

                dispatch(
                    navigateTextInBody(
                        metaDataItemInput.value,
                        { name, indexInput, text },
                        navigateIndex
                    )
                );
            }
            setNavigateIndex(navigateIndex + 1);
        } catch (err) {
            addLog(LOG_TYPE.ERROR, 'MetaDataValue.metadataValueClickHandler', err);
            store.dispatch({
                type: NOTIFICATION_HANDLER.ERROR,
                payload: err
            });
        }
    };

    const navFailed =
        navigationFailedFlag && navigatingTo.name === name && navigatingTo.indexInput === index;

    return (
        <ItemContainer {...rest}>
            <ItemWrapper
                onClick={() => {
                    metadataValueClickHandler(metaDataItem, index);
                }}
                data-testid={`label_${labelIndex}_value_${valuePosition}`}
            >
                <ItemParagraph>{metaDataItem.value}</ItemParagraph>
                {navFailed && <ErrorText>Couldn&#39;t find this label</ErrorText>}
            </ItemWrapper>
        </ItemContainer>
    );
};

export default MetaDataValue;
